import { render, staticRenderFns } from "./ReestablecerContrasenia.vue?vue&type=template&id=23f5d4af&scoped=true"
import script from "./ReestablecerContrasenia.vue?vue&type=script&lang=js"
export * from "./ReestablecerContrasenia.vue?vue&type=script&lang=js"
import style0 from "./ReestablecerContrasenia.vue?vue&type=style&index=0&id=23f5d4af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f5d4af",
  null
  
)

export default component.exports